import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { useIsNRC } from 'lib/util/site-configuration';
import { renderDate } from '../../util';
import { HitHeadline } from '../_HitHeading';
import { HitProps } from '../_types';

export const StandardArticleHit = ({ hit }: HitProps) => {
  const isNetworkSite = useIsNRC();

  return (
    <div>
      <div className={classnames('mb-2')}>
        {isNetworkSite ? (
          <>
            <span className="searchType">Article</span>
            <span
              className={classnames(
                'border-r',
                'h-3',
                'mx-3',
                'inline-block',
                'border-gray-midGray'
              )}
            />
          </>
        ) : (
          <>Article &emsp;| &emsp;</>
        )}
        <Highlight hit={hit} attribute="author" />
      </div>
      <HitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" />
      </HitHeadline>
      {hit.publishedDate && !isNetworkSite && renderDate(hit.publishedDate)}
      <Snippet
        hit={hit}
        attribute="body"
        className={classnames('line-clamp-4', 'md:line-clamp-2')}
      />
    </div>
  );
};
